import { Moment } from "moment";
import Utils from "../utils";
import { SyncDataModel, DataModel, SyncModel } from "./syncModel";
import { ContentType } from "../contentTypes";
import { InternationalisationService } from "../../forked/angular-internationalisation";

export class UserProfileNavigationViewModel {
  public contentType: ContentType;
  public labelDE: string;
  public labelEN: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.labelEN) ? this.labelDE : this.labelEN;
  }
}

export class NavigationTitleViewModel {
  public labelDE: string;
  public labelEN: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.labelEN) ? this.labelDE : this.labelEN;
  }
}

export class NavigationViewModel {
  public contentType: ContentType;
  public order: number;
  public inSubview: boolean;
  public label_de: string;
  public label_en: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public navigationKey: string;
  public svgName: string;
}

// Requests
export class NavigationSyncModel extends SyncModel {
}

// Responses
export class NavigationDataModel extends DataModel {
  public get DM_Key(): number | string { return this.content_type; }
  public content_type: number;
  public release: boolean;
  public sort_nr: number;
  public label_de: string;
  public label_en: string;
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;
}

export class NavigationSyncDataModel extends SyncDataModel {
  public navigation: NavigationDataModel[];
  public get models(): DataModel[] { return this.navigation; }
  public DeserializeType(): void {
    this._DeserializeType(NavigationDataModel);
  }
}
